import { required } from '@/utils/validate';
import { 
  $getGohomeData,
  $getGohomeDataMonthlyAll,
  $saveHoliday,
  $saveSelfExceptTime,
  $deleteSelfExceptTime,
  $getMonthlyWorkTime,
  $getMonthlyRequiredWorkTime,
  $saveModifyTime,
  $deleteModifyTime
} from '@/_api_/gohomeAPI';
import { _loading, _loaded } from '@/actions/commonAction';
import { _updateOutsideInputValue } from '@/actions/outsideAction';
import { _getAlarmFlag } from '@/actions/noticeAction';
import { lpad } from '@/utils/string';
import { toast } from 'react-toastify';
import moment from 'moment';

import types from '@/actions/mainTypes';

/* Actions */
export const _updateEmpNo = (value) => {
  return {
    type: types.UPDATE_EMPNO,
    value: value
  }
}

export const _updateDate = (value) => (dispatch) => {
  dispatch({
    type: types.UPDATE_DATE,
    value: value
  })
  dispatch(_updateOutsideInputValue('startDate', value))
  dispatch(_getGohomeData());
}

export const _getGohomeData = () => async (dispatch, getState) => {
  const state = getState().main;
  if (required(state.empNo)) {
    toast.error("사번을 입력하세요.")
    return;
  }
  dispatch(_loading())
  localStorage.empNo = state.empNo;
  const response = await $getGohomeData(state.empNo, state.date);
  dispatch({
    type: types.SET_GOHOME_DATA,
    data: response.data
  })
  dispatch(_getMonthlyRequiredWorkTime())
  dispatch(_loaded())
  dispatch(_getAlarmFlag())
}

export const _saveHoliday = (date, type) => async (dispatch, getState) => {
  dispatch(_loading())
  await $saveHoliday(getState().main.empNo, date, type)
  dispatch(_closeSaveAttendance())
  if (window.location.pathname === '/calendar') {
    dispatch(_getGohomeDataMonthlyAll())
  } else {
    dispatch(_getGohomeData());
  }
}

export const _openAddExcept = (date, additionalRemovedTime) => {
  const hourminute = (additionalRemovedTime || '00:00').split(":")
  return {
    type: types.OPEN_ADD_EXCEPT,
    date,
    hour: parseInt(hourminute[0], 10),
    minute: parseInt(hourminute[1], 10)
  }
}

export const _closeAddExcept = () => {
  return {
    type: types.CLOSE_ADD_EXCEPT
  }
}

export const _saveSelfExcept = () => async (dispatch, getState) => {
  dispatch(_loading())
  const state = getState().main;
  await $saveSelfExceptTime(state.empNo, state.selfExceptTimeInfo.date, state.selfExceptTimeInfo.hour, state.selfExceptTimeInfo.minute);
  dispatch(_closeAddExcept());
  dispatch(_getGohomeData());
}

export const _deleteSelfExcept = () => async (dispatch, getState) => {
  dispatch(_loading())
  await $deleteSelfExceptTime(getState().main.empNo, getState().main.selfExceptTimeInfo.date);
  dispatch(_closeAddExcept());
  dispatch(_getGohomeData());
}

export const _updateSelfExceptHour = (hour) => {
  return {
    type: types.UPDATE_SELF_EXCEPT_HOUR,
    value: hour
  }
}

export const _updateSelfExceptMinute = (minute) => {
  return {
    type: types.UPDATE_SELF_EXCEPT_MINUTE,
    value: minute
  }
}

export const _updateModifyTimeHour = (hour) => {
  return {
    type: types.UPDATE_MODIFY_TIME_HOUR,
    value: hour
  }
}

export const _updateModifyTimeMinute = (minute) => {
  return {
    type: types.UPDATE_MODIFY_TIME_MINUTE,
    value: minute
  }
}

export const _getMonthlyWorkTime = () => async (dispatch, getState) => {
  dispatch(_loading())
  const response = await $getMonthlyWorkTime(getState().main.empNo, getState().main.date);
  dispatch(_loaded())
  if (typeof response.data === 'string') {
    toast.error(response.data)
    return;
  }
  dispatch({
    type: types.SET_MONTHLY_WORK_TIME,
    data: response.data
  })
}

export const _getMonthlyRequiredWorkTime = () => async (dispatch, getState) => {
  const response = await $getMonthlyRequiredWorkTime(getState().main.date);
  dispatch({
    type: types.SET_MONTHLY_REQUIRED_WORK_TIME,
    type1Hours: response.data.type1,
    type2Hours: response.data.type2,
    requiredHoursType: response.data.currentMonthType
  })
}

export const _openModifyTime = (date, modifyType, time, originTime, modified) => {
  if (date >= moment().format('YYYYMMDD')) return;
  const hourminute = (time || '00:00').split(":")
  const originTimeMoment = moment(originTime).utc();
  return {
    type: types.OPEN_MODIFY_TIME,
    modifyType,
    date,
    hour: parseInt(hourminute[0], 10),
    minute: parseInt(hourminute[1], 10),
    originTime: originTimeMoment.format('YYYYMMDD') > date ? '2400' : originTimeMoment.format('HHmm'),
    modified
  }
}

export const _closeModifyTime = () => {
  return {
    type: types.CLOSE_MODIFY_TIME
  }
}

export const _saveModifyTime = () => async (dispatch, getState) => {
  const state = getState().main;
  const originTime = state.modifyTimeInfo.originTime
  const newTime = lpad(state.modifyTimeInfo.hour,'0',2)+lpad(state.modifyTimeInfo.minute,'0',2)
  if (state.modifyTimeInfo.type === 'first' && originTime >= newTime) {
    toast.error('최초시각은 실제 출입시각보다 늦은 시각이어야 합니다.\n - 실제 최초출입시각 : ' + originTime)
    return;
  } else if (state.modifyTimeInfo.type === 'last' && originTime <= newTime) {
    toast.error('최종시각은 실제 출입시각보다 빠른 시각이어야 합니다.\n - 실제 최종출입시각 : ' + originTime)
    return;
  }
  dispatch(_loading())
  await $saveModifyTime(state.empNo, state.modifyTimeInfo.date, state.modifyTimeInfo.type, lpad(state.modifyTimeInfo.hour,'0',2)+lpad(state.modifyTimeInfo.minute,'0',2));
  dispatch(_closeModifyTime());
  dispatch(_getGohomeData());
}

export const _deleteModifyTime = () => async (dispatch, getState) => {
  dispatch(_loading())
  const state = getState().main;
  await $deleteModifyTime(state.empNo, state.modifyTimeInfo.date, state.modifyTimeInfo.type);
  dispatch(_closeModifyTime());
  dispatch(_getGohomeData());
}

export const _getGohomeDataMonthlyAll = () => async (dispatch, getState) => {
  const state = getState().main;
  if (required(state.empNo)) {
    toast.error("사번을 입력하세요.")
    return;
  }
  dispatch(_loading())
  const curMoment = moment()
  const response = await $getGohomeDataMonthlyAll(state.empNo, curMoment.format('YYYYMMDD'));
  dispatch({
    type: types.SET_GOHOME_DATA_MONTHLY_ALL,
    data: response.data
  })
  dispatch(_loaded())
  dispatch(_getAlarmFlag())
  }

export const _openSaveAttendance = (date, holiday) => {
  return {
    type: types.OPEN_SAVE_ATTENDANCE,
    date,
    holiday
  }
}

export const _closeSaveAttendance = () => {
  return {
    type: types.CLOSE_SAVE_ATTENDANCE
  }
}

export const _openModifyTimeEx = (payload) => {
  const { date, firstTime, lastTime, modified } = payload
  if (date > moment().format('YYYYMMDD')) return;
  const firstHHMM = (firstTime || '09:00').split(":");
  const lastHHMM = (lastTime || '18:00').split(":");
  return {
    type: types.OPEN_MODIFY_TIME_EX,
    date,
    firstHour: parseInt(firstHHMM[0], 10),
    firstMinute: parseInt(firstHHMM[1], 10),
    lastHour: parseInt(lastHHMM[0], 10),
    lastMinute: parseInt(lastHHMM[1], 10),
    modified
  }
}

export const _closeModifyTimeEx = () => {
  return {
    type: types.CLOSE_MODIFY_TIME_EX
  }
}

export const _updateModifyTimeEx = (target, value) => {
  return {
    type: types.UPDATE_MODIFY_TIME_EX,
    target,
    value
  }
}

export const _saveModifyTimeEx = () => async (dispatch, getState) => {
  const state = getState().main
  const { date, firstHour, firstMinute, lastHour, lastMinute } = state.modifyTimeExInfo;
  const newFirstTime = lpad(firstHour, '0', 2) + lpad(firstMinute, '0', 2)
  const newLastTime = lpad(lastHour, '0', 2) + lpad(lastMinute, '0', 2)
  if (newFirstTime >= newLastTime) {
    toast.error('근무 시작 시간이 종료 시간보 앞이어야 합니다.')
    return;
  }
  dispatch(_loading())
  await $saveModifyTime(state.empNo, date, 'first', lpad(firstHour, '0', 2) + lpad(firstMinute, '0', 2));
  await $saveModifyTime(state.empNo, date, 'last', lpad(lastHour, '0', 2) + lpad(lastMinute, '0', 2));
  dispatch(_closeModifyTimeEx());
  dispatch(_getGohomeData());
}

export const _deleteModifyTimeEx = () => async (dispatch, getState) => {
  dispatch(_loading())
  const state = getState().main;
  await $deleteModifyTime(state.empNo, state.modifyTimeExInfo.date, 'first');
  await $deleteModifyTime(state.empNo, state.modifyTimeExInfo.date, 'last');
  dispatch(_closeModifyTimeEx());
  dispatch(_getGohomeData());
}



// WEBPACK FOOTER //
// ./src/actions/mainAction.js